var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._v("\n  登出成功，将在"+_vm._s(_vm.times)+"秒内返回...\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }